// src/pages/Accounting/Receipts/components/Dashboard/ReceiptsList.tsx

import type { Receipt } from "../../types";
import { PALETTE } from "../../constants";
import { ReceiptRow } from "./ReceiptRow";

interface ReceiptsListProps {
  receipts: Receipt[];
  categoriesById: Record<string, string>;
  onRowClick: (id: string) => void;
}

export function ReceiptsList({
  receipts,
  categoriesById,
  onRowClick,
}: ReceiptsListProps) {
  if (receipts.length === 0) {
    return (
      <div
        style={{
          padding: "40px 0",
          fontSize: 13,
          color: PALETTE.ink3,
          borderBottom: `1px solid ${PALETTE.lineSoft}`,
        }}
      >
        No receipts match this filter.
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "80px 1fr 110px 150px 170px 50px",
          gap: 16,
          padding: "14px 0 10px",
          fontSize: 11,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: PALETTE.ink2,
          fontWeight: 700,
          borderBottom: `1px solid ${PALETTE.line}`,
        }}
      >
        <div>Date</div>
        <div>Merchant</div>
        <div style={{ textAlign: "right" }}>Amount</div>
        <div>Status</div>
        <div>Category</div>
        <div />
      </div>
      {receipts.map((r) => (
        <ReceiptRow
          key={r.id}
          receipt={r}
          category={categoriesById[r.id]}
          onClick={() => onRowClick(r.id)}
        />
      ))}
    </div>
  );
}